export const granularityNames = ["YEARLY", "QUARTERLY", "MONTHLY", "WEEKLY", "DAILY", "HOURLY"];

export interface OperativityData {
    date: Date;
    value: number; // Integer
}

export interface Operativities {
    startDate: Date;
    endDate: Date;
    operativityGranularity: any;
    operativities: OperativityData[];
}

export interface OperativityTotals {
    startDate: Date;
    endDate: Date;
    totalEquipments: number;
    operativeEquipment: number;
}
